<template>
  <div class="loading-indicator" role="status">
    <font-awesome-icon :icon="['fal', 'loader']" spin size="2x" />
    <p v-if="message" class="loading-indicator__message">{{ message }}</p>
  </div>
</template>

<script setup lang="ts">
  withDefaults(defineProps<{
    message?: string,
  }>(), {
    message: '',
  });
</script>

<style lang="scss" scoped>
  .loading-indicator {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .loading-indicator__message {
    margin: 0;
  }
</style>
